import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import EsthedermLogo from '@/fo/icons/base/landing/esthederm-white.svg';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './UiLandingFooterEsthederm.styles';

export interface UiLandingFooterEsthedermProps {
  bgFooter: {
    sm: string;
    md: string;
  };
  email?: string;
  footnotes?: Array<{
    id: string;
    content: React.ReactNode;
  }>;
}

export function UiLandingFooterEsthederm({
  bgFooter,
  email,
  footnotes
}: UiLandingFooterEsthedermProps) {
  const slots = styles();
  const t = useTranslations();
  type FooterBgVars = React.CSSProperties &
    Record<'--footer-bg-sm' | '--footer-bg-md', string>;
  const style: Partial<FooterBgVars> = {};
  if (bgFooter.sm) style['--footer-bg-sm'] = `url(${bgFooter.sm})`;
  if (bgFooter.md) style['--footer-bg-md'] = `url(${bgFooter.md})`;

  return (
    <footer className={slots.base()}>
      {footnotes && (
        <div className={slots.footnotes()}>
          {footnotes.map((footnote) => (
            <p
              key={footnote.id}
              className={slots.footnote()}
            >
              {footnote.content}
            </p>
          ))}
        </div>
      )}
      <div
        className={slots.container()}
        style={style}
      >
        <div className={slots.top()}>
          <div className={slots.logo()}>
            <Image
              className={slots.logoImage()}
              src={staticMediaUrl('landing/naos-ecobiology.png')}
              alt="logo"
              width={184}
              height={51}
            />
            <div
              className={slots.text()}
              dangerouslySetInnerHTML={{
                __html: t('landing.footer.titleEsthederm')
              }}
            />
          </div>
          <Link href="/catalog/institut-esthederm/">
            <EsthedermLogo />
          </Link>
        </div>
        <div className={slots.bottom()}>
          <ul className={slots.list()}>
            <li className={slots.listItem()}>{t('landing.footer.rights')}</li>
            <li className={slots.listItem()}>{t('landing.footer.company')}</li>
            <li className={slots.listItem()}>
              <Link
                className={slots.link()}
                target="_blank"
                href="/legal/politika-konfidentsialnosti/"
              >
                {t('landing.footer.privacy')}
              </Link>
            </li>
          </ul>
          <div className={slots.contacts()}>
            <Link
              className={slots.phone()}
              href="tel:88007759359"
            >
              8 800 775 93 59
            </Link>
            {email && (
              <Link
                className={slots.email()}
                href={`mailto:${email}`}
              >
                {email}
              </Link>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
